import i18n from "@/i18n";
import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter.js";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '수행일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['수행일', '점검자수']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'body.수행일', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.수행일', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "수행일",
        "key": "body.수행일"
      },
      {
        "name": "점검자수",
        "key": "body.순회점검자명단"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name // 회사명
        case 1:
          return func.getContent(value).수행일 // 수행일
        case 2:
          return func.getContent(value).순회점검자명단.length // 점검자수
        case 3:
          return func.getContent(value).stdInfo.department // 소속명
        case 4:
          return func.getContent(value).stdInfo.section // 부서명
        case 5:
          return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  // =================================================================================================================
  // 엑셀 다운로드 설정 (목록형 단일 시트 - 템플릿 파일 없이 코드에서 직접 생성)
  //  - 1행 헤더, 2행부터 채운다. 유해위험작업(항목) "1건당 1행"으로 펼친다.
  //  - 문서 단위 정보(구분/부서명/수행자/수행일/수행시간)는 각 문서의 첫 행에만 표기한다.
  //  컬럼: A 구분(빈값) / B 부서명(com_name) / C 수행자(수행자성명) / D 수행일 / E 수행시간 /
  //        F 유해·위험작업 장소 / G 내용 / H 유해위험정도 / I 사고,질병의 유형 / J 기타내용
  //  ※ I(사고·질병의 유형)가 "기타"인 경우 J에 기타내용(기타사고/기타질병)을 표기한다.
  excelInfo: (dataList) => {
    const HEADER = [
      "구분", "부서명", "수행자", "수행일", "수행시간", "유해·위험작업 장소", "내용",
      "유해위험정도", "사고, 질병의 유형", "기타내용",
    ];

    // 앞의 원문자(①~⑮ 등) 접두어 제거
    const stripNum = (s) => {
      const v = typeof s === "string" ? s : s && (s.label || s.value) ? `${s.label || s.value}` : "";
      return v.replace(/^[①-⓿]\s*/, "").trim();
    };

    return {
      downloadFileName: "유해·위험요인 조사 결과",
      worksheetName: () => "유해·위험요인 조사 결과",
      singleSheet: (worksheet, posts) => {
        // 헤더 (1행)
        HEADER.forEach((h, ci) => {
          worksheet.getRow(1).getCell(ci + 1).value = h;
        });

        // 데이터 (2행부터)
        let rowIdx = 2;
        posts.forEach((post) => {
          let body = {};
          try {
            body = JSON.parse(post.post_content).body || {};
          } catch (e) { /* ignore */ }
          const std = body.stdInfo || {};

          // 문서 단위 값
          const 부서명 = std.com_name || "";
          const 수행자 = body.수행자성명 || "";
          const 수행일 = body.수행일 || "";
          const t = body.수행시간 || {};
          const 수행시간 = t.sTime || t.eTime ? `${t.sTime || ""} ~ ${t.eTime || ""}` : "";

          const items = Array.isArray(body.유해위험작업) ? body.유해위험작업 : [];
          // 항목이 없는 문서도 한 줄로 표기한다.
          const rows = items.length > 0 ? items : [null];

          rows.forEach((it, idx) => {
            const row = worksheet.getRow(rowIdx++);
            if (idx === 0) {
              // 문서 단위 정보는 첫 행에만
              row.getCell(1).value = ""; // A 구분 (빈값)
              row.getCell(2).value = 부서명; // B 부서명
              row.getCell(3).value = 수행자; // C 수행자
              row.getCell(4).value = 수행일; // D 수행일
              row.getCell(5).value = 수행시간; // E 수행시간
            }
            if (it) {
              const 유형목록 = Array.isArray(it.사고질병유형) ? it.사고질병유형.map(stripNum).filter((v) => v !== "") : [];
              const 기타내용 = [it.기타사고, it.기타질병].filter((v) => v).join(", ");

              row.getCell(6).value = it.장소 || ""; // F 장소
              row.getCell(7).value = it.내용 || ""; // G 내용
              row.getCell(8).value = it.정도 || ""; // H 유해위험정도
              row.getCell(9).value = 유형목록.join(", "); // I 사고, 질병의 유형
              row.getCell(10).value = 기타내용; // J 기타내용
            }
          });
        });
      },
    };
  },

  // 전체 다운로드(모든 문서 엑셀다운로드) - 새 워크북에 목록형으로 채운 뒤 다운로드
  customExcelDownload: async (dataList, title) => {
    const excelInfo = list.excelInfo(dataList);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelInfo.worksheetName ? excelInfo.worksheetName() : "Sheet1");
    excelInfo.singleSheet(worksheet, dataList);
    await excelSupporter.workbookDownload(workbook, excelInfo.downloadFileName);
  },
}

export default list;
